import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainMedicalRoutingModule } from './main-medical-routing.module';



// OTHER MODULE IMPORTS

import { SharedModule } from '../../shared.module';
import { MaterialsModule } from '../../materials.module';

// IMPORT MEDICAL MODULE COMPONENTS

import { MainMedicalComponent } from './main-medical.component';
import { FormComponent } from '../form/form.component';
import { TestedIndividualComponent } from '../tested-individual/tested-individual.component';
import { AddCandidateModalComponent } from '../add-candidate-modal/add-candidate-modal.component';
import { ConsentFormComponent } from '../consent-form/consent-form.component';
import { Form2Component } from '../form2/form2.component';
import { MedicalStatusComponent } from '../medical-status/medical-status.component';
import { EditCandidateModalComponent } from '../edit-candidate-modal/edit-candidate-modal.component';
import { MedicalStatusComfirmModalComponent } from '../medical-status/medical-status-comfirm-modal/medical-status-comfirm-modal.component';
import { PoctTestFormComponent } from '../poct-test-form/poct-test-form.component';
import { BreathAlcoholFormComponent } from '../breath-alcohol-form/breath-alcohol-form.component';



@NgModule({
  declarations: [
    MainMedicalComponent,
    FormComponent,
    TestedIndividualComponent,
    AddCandidateModalComponent,
    ConsentFormComponent,
    Form2Component,
    MedicalStatusComponent,
    EditCandidateModalComponent,
    MedicalStatusComfirmModalComponent,
    PoctTestFormComponent,
    BreathAlcoholFormComponent
  ],
  imports: [
    CommonModule,
    MainMedicalRoutingModule,
    SharedModule,
    MaterialsModule,
  ],
  entryComponents: [
    AddCandidateModalComponent,
    EditCandidateModalComponent,
    MedicalStatusComfirmModalComponent
  ],
  exports: [
    MedicalStatusComponent,
    TestedIndividualComponent,
    FormComponent,
    ConsentFormComponent,
    Form2Component,
    PoctTestFormComponent,
    BreathAlcoholFormComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainMedicalModule { }
